import { initCinematicHero } from './landing/cinematicHero';
import { initLandingScrollStories } from './landing/scrollStories';

export function initHomeHero(): void {
    initCinematicHero();
    initLandingScrollStories();
}
